import React, { useContext, useState } from 'react'
import { Box, Text } from '@usap/uicomponents'
import { BoxWithPointer } from '@usap/widgets'

import seoIDs from '../../../../../config/seoIds'

import { LocalContext } from '../../../../helpers/useLocalContext'

const sequence = ['year', 'make', 'model', 'submodel', 'engine', 'fnotes']

export default function VehicleFitment(props) {
  const {
    fitNotes,
    index,
    sku,
    expandFitment,
  } = props

  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext

  const [moreFitments, showMoreFitments] = useState(expandFitment)
  const limit = isBot ? fitNotes.length : 3

  const hasFitNotes = Boolean(fitNotes && fitNotes.length)
  const toogleButtonId = moreFitments ? `viewLessVehicles-${sku}-${index}` : `seeAllVehicles-${sku}-${index}`
  const toggleButtonLabel = moreFitments ? 'View Less' : 'See All Vehicles'

  return hasFitNotes ? (
    <Box pad={{ bottom: 'small' }}>
      <Text size="xsmall" weight="bold">
        Vehicle Fitment
      </Text>

      <Box>
        <Box>
          <ul
            style={{
              fontSize: '12px',
              lineHeight: '1',
              margin: '0px',
              padding: '0px',
              paddingLeft: '15px',
            }}
          >
            {fitNotes.map((selectedVehicle, pindex) => {
              const value = sequence.reduce((string, key) => {
                let stringInstance = string
                if (selectedVehicle[key]) {
                  stringInstance = `${stringInstance}${
                    stringInstance ? ' ' : ''
                  }${selectedVehicle[key]}`
                }
                return stringInstance
              }, '')

              if (pindex < limit || moreFitments) {
                return (
                  <li
                    key={value.replace('  ', '_')}
                    style={{
                      listStyle: 'disc outside',
                    }}
                  >
                    <Text size="xsmall" color="dark-2">
                      {`${value.replace('  ', '')}`}
                    </Text>
                  </li>
                )
              }
              return ''
            })}
          </ul>
        </Box>

        {!isBot && fitNotes.length > limit && (
          <BoxWithPointer
            id={toogleButtonId}
            alignSelf="start"
            align="center"
            onClick={() => showMoreFitments(!moreFitments)}
          >
            <Text
              id={seoIDs.vfSeeAll.replace('{{key}}', index)}
              size="xsmall"
              color="#05629b"
            >
              {toggleButtonLabel}
            </Text>
          </BoxWithPointer>
        )}
      </Box>
    </Box>
  ): ''
}
